import GVSelect from 'components/lib/GVSelect/GVSelect';
import { useCTFVersion } from './ctfVersionStore';
import styles from './VersionSelector.module.scss';

const VersionSelector = () => {
  const { availableVersions, versionOverride, overrideVersion } = useCTFVersion();

  console.log({ availableVersions, versionOverride });

  const selectedVersion = availableVersions.find((version) => version === versionOverride) ?? null;

  const options = availableVersions.map((version) => ({
    label: version,
    value: version,
  }));

  return (
    <div className={styles.root}>
      <GVSelect
        id="dropdown"
        label={<span className={styles.label}>Select Version</span>}
        value={selectedVersion}
        onValueChange={overrideVersion}
        options={options}
        className={styles.select}
      />
    </div>
  );
};

export default VersionSelector;
